<mat-expansion-panel
    [expanded]="expanded"
    [hideToggle]="hideToggle"
    [disabled]="disabled"
>
    <mat-expansion-panel-header
        [ngStyle]="disabled ? { cursor: 'default' } : null"
    >
        <mat-panel-title
            class="flex space-x-2 !text-tertiary-900 font-normal text-xl py-2"
        >
            <h1 class="text-tertiary-900 font-normal !text-xl !m-0">
                Technical Data
            </h1>
        </mat-panel-title>
    </mat-expansion-panel-header>

    <dl class="grid grid-cols-[3fr_2fr] gap-x-2 gap-y-3 ps-3 items-center my-2">
        <dt [innerHTML]="frequencyTypeTitle"></dt>
        <dd>{{ frequencyTypeSummary }}</dd>

        <dt [innerHTML]="locationTypeTitle"></dt>
        <dd>{{ locationTypeSummary }}</dd>

        <dt [innerHTML]="stationClassTitle"></dt>
        <dd [innerHTML]="stationClassSummary"></dd>

        <dt [innerHTML]="numberOfFrequenciesTitle"></dt>
        <dd>{{ numberOfFrequenciesSummary }}</dd>

        <dt [innerHTML]="coordinatesTitle"></dt>
        <dd [innerHTML]="coordinatesSummary"></dd>

        <dt [innerHTML]="antennaHeightTitle"></dt>
        <dd>{{ antennaHeightSummary }}</dd>

        <dt [innerHTML]="minimumErpRequiredTitle"></dt>
        <dd [innerHTML]="minimumErpRequiredSummary"></dd>

        <dt [innerHTML]="emissionDesignatorTitle"></dt>
        <dd [innerHTML]="emissionDesignatorSummary"></dd>
    </dl>
</mat-expansion-panel>
